<template>
  <div
    class="bkwishlist"
  >
    <template v-if="isLoggedIn">
      <a
        class="wishlist-icon-list addToWishlistCategory"
        :class="{ active: isVariationInWishList(), loading: (!isInitiallyLoaded || wishlistIsLoading) }"
        @click="openAddToWishlist()"
      >
        <i
          class="fa fas fa-heart"
        />
      </a>
    </template>
    <template v-else>
      <a
        href="#login"
        data-toggle="modal"
        class="wishlist-icon-list addToWishlistCategory"
        :class="{ loading: (!isInitiallyLoaded || wishlistIsLoading) }"
        @click="loadRegistrationModal();"
      >
        <i
          class="fa fas fa-heart"
        />
      </a>
    </template>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import loadWishlistModule from '../mixins/loadWishlistModule'

export default {
  name: 'BkAddToWishlist',
  mixins: [loadWishlistModule],
  props: {
    variationId: Number
  },
  data () {
    return {
      newWishlistName: ''
    }
  },
  computed: {
    ...mapState({
      userWishlists: state => state.bkwishlist.userWishlists,
      isInitiallyLoaded: state => state.bkwishlist.userWishlistsInitiallyLoaded
    }),
    ...mapGetters({
      isLoggedIn: 'isLoggedIn',
      wishlistIsLoading: 'loading'
    })
  },
  mounted () {

  },
  methods: {
    loadRegistrationModal () {
      this.loadComponent('register-modal')
      this.loadComponent('login-modal')
    },
    isVariationInWishList () {
      return (this.userWishlists.filter(list => list.wishlistItems.includes(this.variationId)).length > 0)
    },
    openAddToWishlist () {
      this.$store.dispatch('setAddToWishlistData', { variationId: this.variationId })
      $('#add-to-wishlist-modal').modal('show')
    },
    ...mapActions([
      'loadComponent'
    ])
  }
}
</script>
